import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { IconName } from '@sc/data-access-assets';
import { ButtonComponent } from '../button';
import { IconComponent } from './../icon';

@Component({
  selector: 'sc-success-box',
  styleUrls: ['./success-box.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, IconComponent, ButtonComponent],
  template: `
    <div class="container">
      <sc-icon [name]="iconName" [specificName]="iconSpecificName"></sc-icon>
      <div class="title-container">
        <h1 class="sc-design-title-h1" [innerHTML]="title"></h1>
        <p class="sc-design-text-1" [innerHTML]="text"></p>
        <sc-button
          buttonType="primary"
          class="sc-conf-b2c-display-success-box-btn"
          *ngIf="!!buttonText?.length"
          (click)="onClick()"
          >{{ buttonText }}</sc-button
        >
      </div>
    </div>
  `,
})
export class SuccessBoxComponent {
  @Input() title: string;
  @Input() text: string;
  @Input() displayButton = false;
  @Input() buttonText: string;
  @Input() iconName: IconName = 'check';
  @Input() iconSpecificName = 'upload_end_page';
  @Output() buttonClick = new EventEmitter();

  onClick() {
    this.buttonClick.emit();
  }
}
